import type { FC, ReactNode } from 'react';
import { Drawer as ADrawer, Col, type DrawerProps, Row } from 'antd';

import { ENV_VARS } from '@/env';

import { ReactComponent as Close } from '../../../assets/icons/close-white.svg';
import IconButton from '../Buttons/IconButton';

interface DrawerCustomProps extends DrawerProps {
  headerContents?: ReactNode;
  classFieldName?: string;
  contentClassName?: string;
  dataTestId?: string;
  zIndex?: number;
}

const Drawer: FC<DrawerCustomProps> = ({
  open = false,
  children,
  onClose = () => {},
  headerContents = '',
  classFieldName = '',
  width = '70%',
  afterOpenChange = () => {},
  contentClassName = '',
  destroyOnHidden = false,
  forceRender = false,
  dataTestId = '',
  zIndex,
}) => {
  const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

  return (
    <ADrawer
      className="shipment-drawer-container"
      placement="right"
      open={open}
      zIndex={zIndex}
      styles={{ wrapper: { width: `${width}` } }}
      onClose={() => {}}
      afterOpenChange={afterOpenChange}
      destroyOnHidden={destroyOnHidden}
      forceRender={forceRender}
      data-testid={dataTestId}
    >
      <div className="vh-100 d-flex flex-direction-column overflow-y-inherit">
        <div
          className={`${classFieldName} ${
            isHBUser ? 'hb-bg-color' : ''
          } py-16 px-30 background-header filter-shadow border-none`}
        >
          <Row justify="space-between" className="align-items-center">
            <Col className="flex-1">{headerContents}</Col>
            <Col className="d-flex">
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </Col>
          </Row>
        </div>
        <div className={`${contentClassName} h-100 overflow-hidden flex-1`}>{children}</div>
      </div>
    </ADrawer>
  );
};

export default Drawer;
